<template>
    <div class="recruit_container">
        <div class="recruit_section05">
            <div class="recruit_head">04. 지원방법</div>
            <div class="text_container">
                <div class="condition_details">
                    <div class="detail_title">
                        <span class="recruit_body_bold">접수방법</span>
                    </div>
                    <div class="vertical_line"></div>
                    <div class="detail_content">
                       <span class="recruit_body">
                            채용 포털사이트 (사람인, 잡코리아) 지원
                        </span>
                    </div>
                </div>
                <div class="condition_details">
                    <div class="detail_title">
                       <span class="recruit_body_bold">제출서류</span>
                    </div>
                    <div class="vertical_line"></div>
                    <div class="detail_content">
                        <div class="pc">
                            <span class="recruit_body">
                                잡코리아, 사람인 등 구직 사이트에 등록된 이력서 양식으로 제출 가능 <br>
                                (경력직은 포트폴리오 제출 필수)
                            </span>
                        </div>
                        <div class="phone">
                            <span class="recruit_body">
                                잡코리아, 사람인 등 구직 사이트에 <br> 등록된 이력서 양식으로 제출 가능 <br>
                                (경력직은 포트폴리오 제출 필수)
                            </span>
                        </div>
                    </div>
                </div>
                <div class="condition_details">
                    <div class="detail_title">
                    <span class="recruit_body_bold">문의사항</span>
                    </div>
                    <div class="vertical_line"></div>
                    <div class="detail_content">
                        <span class="recruit_body">
                            아래 메일로 문의 부탁드립니다. <br>
                            recruit@datau.co.kr
                        </span>
                    </div>
                </div>
                <div class="condition_details">
                    <span class="recruit_body_grey">* 최종 합격자에 한하여 추가 증빙 자료가 요청될 수 있습니다.</span>
                </div>
            </div>
            <div class="btn_container">
                <v-btn class="jobkorea_btn" :width="btnWidth" :height="btnHeight" color="#3399ff" @click="link('https://www.jobkorea.co.kr/net/Recruit/Co_Read/C/datauniverse')">
                    <div class="service_btn_home">잡코리아 모집공고 바로가기</div>
                    <div class="ph_service_btn_home">잡코리아 모집공고<br> 바로가기</div>
                </v-btn>
                <v-btn class="saramin_btn" :width="btnWidth" :height="btnHeight" color="#4876ef" @click="link('https://www.saramin.co.kr/zf_user/company-info/view?csn=ZmYxbk5TQUIyTmpodWxxN0FmNys0Zz09')">
                    <div class="service_btn_home">사람인 모집공고 바로가기</div>
                    <div class="ph_service_btn_home">사람인 모집공고<br> 바로가기</div>
                </v-btn>
            </div>
        </div>
    </div>
</template>
<script>
import PageLink from '../../api/mixin/pageLink'
export default {
	name: 'section05',
	mixins: [PageLink],
	computed: {
		btnWidth () {
			switch (this.$vuetify.breakpoint.name) {
			default: return 389
			case 'xs': return 124
			case 'sm': return 231
			}
		},
		btnHeight () {
			switch (this.$vuetify.breakpoint.name) {
			default: return 72
			case 'xs': return 51
			case 'sm': return 43
			}
		}
	}
}
</script>
